import { Component } from '@angular/core';

@Component({
  selector: 'app-instructed-cases-list',
  templateUrl: './instructed-cases-list.component.html',
  styleUrls: ['./instructed-cases-list.component.css']
})
export class InstructedCasesListComponent {

}
